import { useMemo } from 'react'
import moment from 'moment'
import { Slider, Theme, sliderClasses } from '@mui/material'
import { NullableDate } from './date.d'

interface IProps {
  startDate: NullableDate
  endDate: NullableDate
  licenseEndDate: NullableDate | string
  licenseStartDate: NullableDate | string
}

const style = {
  [`&.${sliderClasses.thumb}`]: {
    // same styling as the default thumb, without a foucs/hover state
    position: 'absolute',
    width: '12px',
    height: '12px',
    marginLeft: '-6px',
    marginTop: '-5px',
    boxSizing: 'border-box',
    borderRadius: '50%',
    outline: 0,
    backgroundColor: 'currentColor',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'default',
    transition: (theme: Theme) =>
      theme.transitions.create(['box-shadow'], {
        duration: theme.transitions.duration.shortest
      }),
    '&::after': {
      position: 'absolute',
      content: '""',
      borderRadius: '50%',
      // reach 42px hit target (2 * 15 + thumb diameter)
      left: '-15px',
      top: '-15px',
      right: '-15px',
      bottom: '-15px'
    },
    [`&.${sliderClasses.focusVisible},:hover`]: {
      boxShadow: 'none'
    },
    [`&.${sliderClasses.active},&:active`]: {
      boxShadow: `none`
    }
  }
}

export const HaynesProDateSparkLine = ({ startDate, endDate, licenseStartDate, licenseEndDate }: IProps) => {
  const momentLicenseEndDate = useMemo(
    () => (typeof licenseEndDate === 'string' ? moment(licenseEndDate) : licenseEndDate),
    [licenseEndDate]
  )
  const momentLicenseStartDate = useMemo(
    () => (typeof licenseStartDate === 'string' ? moment(licenseStartDate) : licenseStartDate),
    [licenseStartDate]
  )
  const totalRange = useMemo(() => endDate?.diff(startDate!, 'days') || 1, [startDate, endDate])

  const sliderVal = useMemo(() => {
    const sliderStart =
      momentLicenseStartDate && momentLicenseStartDate.diff(startDate!, 'days') > 0 ? momentLicenseStartDate?.diff(startDate!, 'days') : 0
    const sliderEnd = momentLicenseEndDate?.diff(startDate!, 'days') || 1

    return [sliderStart, sliderEnd]
  }, [momentLicenseStartDate, momentLicenseEndDate, startDate])

  if (!startDate || !endDate || !licenseEndDate || totalRange < 0) {
    return null
  }
  return (
    <Slider
      valueLabelDisplay='off'
      onChange={() => {
        /* empty onchange to hide elements */
      }}
      marks
      value={sliderVal}
      step={7}
      min={0}
      max={totalRange}
      sx={{ cursor: 'default !important', ...style }}
    />
  )
}

export default HaynesProDateSparkLine
